import { useState } from 'react';
import { updateRenewAmount } from '@/services/account/api';
import { useAuth } from '@/contexts/auth';

export function useCredits() {
  const { partner, refreshUser } = useAuth();
  const [selectedAmount, setSelectedAmount] = useState(
    parseInt(partner.renew_amount) || 100,
  );

  const [renewCreditSwitch, setRenewCreditSwitch] = useState(
    !!parseInt(partner.renew_amount),
  );

  const updateSelectedAmount = async value => {
    setSelectedAmount(value);
    if (renewCreditSwitch) {
      await updateRenewAmount({ renew_amount: `${value}00` }).then(() => {
        refreshUser();
      });
    }
  };

  return {
    renewCreditSwitch,
    setRenewCreditSwitch,
    selectedAmount,
    updateSelectedAmount,
  };
}
